// TODO This is a Non-org user.  Once User is renamed to OrgUser, this should be renamed to User

import _pick from 'lodash/pick';

const FIELDS = [
  'id',
  'firstName',
  'middleName',
  'lastName',
  'phone',
  'loginEmail',
  'recoveryEmail',
  'timeZoneId',
  'preferences',
  'rowVersion'
];

const User = () => {
  return {
    id: null,
    firstName: '',
    lastName: '',
    phone: '',
    timeZoneId: '',
    preferences: null
  };
};

export const sanitize = values => {
  const {
    id,
    rowVersion,
    firstName,
    lastName,
    phone,
    timeZoneId,
    preferences,
    ...initialValues
  } = _pick(values, FIELDS);

  if (id) {
    return {
      id,
      firstName,
      lastName,
      phone,
      timeZoneId,
      preferences,
      rowVersion
    };
  }
  return {
    ...initialValues,
    firstName,
    lastName,
    phone,
    timeZoneId,
    preferences
  };
};

export default User;
